import { isTauri } from './isTauri';

/**
 * Save a text file: the native save dialog + `writeTextFile` in the desktop
 * app, a Blob download in a browser. Returns `{ saved, path? }` or
 * `{ saved: false, cancelled: true }` when the user dismisses the dialog.
 *
 * Moved out of components/documentExport.js so other exports (chat history)
 * reuse it. `title` is the dialog title; its default keeps the document
 * export's dialog exactly as it was.
 */
export async function saveTextFile({ content, filename, mime, filters, title = 'Export document' }) {
  if (isTauri()) {
    const { save } = await import('@tauri-apps/plugin-dialog');
    const { writeTextFile } = await import('@tauri-apps/plugin-fs');
    const filePath = await save({ defaultPath: filename, title, filters });
    if (filePath == null) return { saved: false, cancelled: true };
    await writeTextFile(filePath, content);
    return { saved: true, path: filePath };
  }
  const blob = new Blob([content], { type: mime });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
  return { saved: true };
}
